import React, { useState ,useEffect} from 'react';
import './rules.css'
import Beard from '../../assets/images/logo-beard2.svg'
import Footer from '../../layout/footer/footer'
import { Accordion, Col, Form } from 'react-bootstrap';
import {getTermsConditions} from '../../utils/api'

function Faq() {
    const [text , setText] = useState('')

    const getRule = async () => {
        try {
          let res = await getTermsConditions()
          setText(res.data.data)
        } catch (error) {
    
        }
      }
      useEffect(() => {
        getRule()
      }, [])
      function convertToPersianNumbers(input) {
        const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        return input.replace(/\d/g, (digit) => persianDigits[digit]);
      }
    return (
        <>
            <div className='container color-changes'>
                <div className='d-flex align-items-center title gap-3'><img src={Beard} alt="" />قوانین و مقررات</div>
                {/* <p dangerouslySetInnerHTML={{ __html: text}} /> */}
                <div className='text-justify mt-5'>
                    <h5 className="font-bold">"من قوانین سایت را مطالعه کردم آن‌ها را قبول دارم و آن‌را به‌صورت مجازی امضا می‌کنم"</h5>
                </div>
                <p className=" text-justify mt-4 text-base">
                    استفاده شما از وب‌سایت کارت هدیه کادونا به معنی توافق کامل شما با شرایط مندرج در این صفحه است. این توافق‌نامه با توجه به قوانین جمهوری اسلامی ایران تنظیم شده است و به معنی توافق کامل کاربر، با شرایط موجود جهت استفاده از کارت هدیه کادونا خواهد بود.
                </p>
                <p className=" text-justify mt-4 text-base mb-5">
{

                convertToPersianNumbers('(( با توجه به قانون مبارزه با پول‌شوئی مصوب 1386/11/02 مجلس شورای اسلامی و همچنین اصلاح قانون مبارزه با پول‌شوئی مصوب 97/07/03 و اصلاحات و الحاقات بعدی آن، بدین‌وسیله متعهد و ملزم می‌شوم ضمن رعایت قوانین و مقررات مربوطه، از هر گونه اقدامی که منجر به پول‌شوئی شود خودداری نموده و همچنین به اشخاص ثالث اجازه استفاده از حساب‌ها و خدمات بانکی و ابزارهای بانکداری الکترونیکی خود را ندهم و در صورت اقدام ، موضوع را بلافاصله به فناوران تراکنش سپاس اطلاع دهم همچنین در صورت بروز مشکل در این زمینه، تمامی مسئولیت‌ها متوجه اینجانب است. در ادامه اعلام می نمایم اطلاعات ارائه شده بر اساس آخرین تغییرات است و متعهد می شوم هر گونه تغییر در آدرس و کد پستی ثبتی و سایر تغییرات را در کوتاه‌ترین زمان ممکن به مراجع قانونی ذی‌ربط ( ثبت‌احوال، اداره ثبت‌اسناد و املاک ) اطلاع داده و مستندات را به فناوران تراکنش سپاس ارائه نمایم . ))')
}
                </p>

                <div className="
                
                border-custome-dash
                [&>.item]:bg-[#fff] 
                [&>.item]:border-[#99B3FF] 
          
                [&>.item]:rounded-lg 
                [&>.item]:p-3 
                [&>.item]:flex 
                [&>.item]:flex-col 
                [&>.item]:justify-center 
                [&>.item]:items-center
                [&>.item]:text-start
                [&>.item]:my-2
                ">
                    <div className="item">
                        <img src={require('../../assets/icons/rules/person.svg').default} alt="" className='w-10' />
                        <h5 className='text-[#3366FF] font-bold my-3'>سیاست حفظ حریم شخصی کاربران</h5>
                        <div className="text-lg font-bold w-100 text-center">کارت هدیه کادونا به اطلاعات مخفی یا خصوصی اشخاصی که از خدمات سایت استفاده می کنند، احترام گذاشته و از آن محافظت می‌کند.</div>
                    </div>
                    <div className="item">
                        <img src={require('../../assets/icons/rules/person.svg').default} alt="" className='w-10' />
                        <h5 className='text-[#3366FF] font-bold my-3'>درخواست اطلاعات شخصی شما</h5>
                        <div className="text-lg font-bold w-100 text-center">وب سایت کارت هدیه کادونا اقدام به دریافت اطلاعاتی می کند که هنگام ارسال سفارش خرید کالاها، بر مبنای آن بتوان سفارش را در اسرع وقت و با هماهنگی قبلی تحویل دهد. این اطلاعات توسط کارت هدیه کادونا برای انجام عملیات بهتر، حفظ کیفیت سرویس ها و تامین اطلاعات آماری مورد استفاده قرار می گیرد.</div>
                    </div>
                    <div className="item">
                        <img src={require('../../assets/icons/rules/cart.svg').default} alt="" className='w-10' />
                        <h5 className='text-[#3366FF] font-bold my-3'>درخواست کارت هدیه عمومی</h5>
                        <div className="text-lg font-bold w-100 text-center">هزینه صدور و شخصی‌سازی در زمان ثبت کارت از طریق پیامک به اطلاع شما می‌رسد.</div>
                    </div>
                    <div className="item">
                        <img src={require('../../assets/icons/rules/cart.svg').default} alt="" className='w-10' />
                        <h5 className='text-[#3366FF] font-bold my-3'>درخواست کارت هدیه با متن و تصویر اختصاصی</h5>
                        <div className="text-lg font-bold w-100 text-center">
                        تصویر شخصی افراد صرفاً می تواند با پوشش منطبق بر معیارهای جامعه ایرانی اسلامی باشد.
                        <ul>
                            <li>عکس ارسالی می‌بایست دارای طول و عرض استاندارد باشد‌. بعد از ارسال عکس، سیستم به طور خودکار اندازه عکس را تنظیم می‌کند.در صورت عدم استفاده از ابعاد استاندارد ممکن است تصویر ارسالی دارای کشیدگی یا جمع‌شدگی گردد.</li>
                            <li>متن و تصویر درخواستی بر روی کارت هدیه می‌بایست واضح و منطبق با معیارهای جامعه ایرانی اسلامی باشد که بر این اساس فناوران تراکنش سپاس پس از بررسی متن و تصویر آن را تأیید یا رد نماید.</li>
                            <li>در صورت انتخاب متن یا طرح مرتبط با معرفی شرکت، سازمان یا محصول، ابتدا متن و طرح ثبت شده، مورد بررسی قرار گرفته و در صورت تأیید، چاپ کارت انجام خواهد پذیرفت.</li>
                        </ul>
                        </div>
                    </div>
                    <div className="item">
                        <img src={require('../../assets/icons/rules/car.svg').default} alt="" className='w-10' />
                        <h5 className='text-[#3366FF] font-bold my-3'>صدور کارت و ارسال سفارش ها</h5>
                        <div className="text-lg font-bold w-100 text-center">
                        در صورت فعال‌سازی کارت قبل از دریافت کارت هدیه از طریق پست، کلیه پیامدهای آن نظیر مفقودی، سرقت موجودی کارت و ... بر عهده مشتری است.
                        <ul>
                            <li>شرایط و ضوابط استفاده از کارت هدیه، مطابق با مصوبات بانک مرکزی جمهوری اسلامی ایران است.</li>
                        </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="home-footer mt-40">
                <Footer />
            </div>
        </>
    )
}

export default Faq